/* TomorrowMade — product page behavior (variant selection, gallery, qty,
   AJAX add-to-cart, accordions, sticky bar). Reads variant data from a
   JSON script tag rendered by the section. */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var dataEl = document.getElementById('ProductVariantsJSON');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  var selected = {}; // option position (1-based) -> value
  // initialise from currently-on buttons
  root.querySelectorAll('[data-opt]').forEach(function (btn) {
    if (btn.classList.contains('on')) selected[btn.getAttribute('data-opt')] = btn.getAttribute('data-value');
  });

  var priceEl = root.querySelector('.info__price');
  var addBtn = root.querySelectorAll('[data-add]');
  var idInput = root.querySelector('input[name="id"]');
  var mainImg = document.getElementById('mainimg');
  var galTag = document.getElementById('galtag');
  var sizeVal2 = document.getElementById('sizeval2');

  function currentVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return selected[(i + 1).toString()] === val; });
    });
  }

  function priceHtml(v) {
    var html = formatMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      html = '<s style="color:var(--steel);font-weight:400">' + formatMoney(v.compare_at_price) + '</s> ' + html;
    }
    return html;
  }

  function update() {
    var v = currentVariant();
    if (idInput) idInput.value = v ? v.id : '';
    var allSelected = root.querySelectorAll('[data-opt-group]').length === Object.keys(selected).length;

    addBtn.forEach(function (b) {
      if (!allSelected) { b.disabled = false; b.textContent = b.getAttribute('data-label-select') || 'Select options'; }
      else if (!v || !v.available) { b.disabled = true; b.textContent = 'Sold out'; }
      else { b.disabled = false; b.textContent = (b.getAttribute('data-label-add') || 'Add to bag') + ' — ' + formatMoney(v.price); }
    });

    if (v && priceEl) {
      priceEl.innerHTML = priceHtml(v) + (priceEl.getAttribute('data-suffix') ? ' <small>' + priceEl.getAttribute('data-suffix') + '</small>' : '');
    }
    if (v && v.featured_media && mainImg) {
      mainImg.style.opacity = 0;
      setTimeout(function () { mainImg.src = v.featured_media.preview_image.src; mainImg.style.opacity = 1; }, 160);
    }
    if (sizeVal2) sizeVal2.textContent = selected['2'] || selected['1'] || 'select size';
  }

  // option buttons / swatches
  root.querySelectorAll('[data-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('out')) return;
      var pos = btn.getAttribute('data-opt');
      root.querySelectorAll('[data-opt="' + pos + '"]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      selected[pos] = btn.getAttribute('data-value');
      var lbl = root.querySelector('[data-optval="' + pos + '"]');
      if (lbl) lbl.textContent = btn.getAttribute('data-value');
      update();
    });
  });

  /* gallery swap */
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.toggle('on', x === t); });
      if (!mainImg) return;
      mainImg.style.opacity = 0;
      setTimeout(function () {
        mainImg.src = t.getAttribute('data-full');
        if (galTag && t.getAttribute('data-tag')) galTag.textContent = t.getAttribute('data-tag');
        mainImg.style.opacity = 1;
      }, 180);
    });
  });

  /* qty */
  var q = 1;
  var qv = document.getElementById('qv');
  var qInput = root.querySelector('input[name="quantity"]');
  function setQ(n) { q = Math.max(1, Math.min(99, n)); if (qv) qv.textContent = q; if (qInput) qInput.value = q; }
  var qm = document.getElementById('qminus'), qp = document.getElementById('qplus');
  if (qm) qm.addEventListener('click', function () { setQ(q - 1); });
  if (qp) qp.addEventListener('click', function () { setQ(q + 1); });

  /* toast */
  var toast = document.getElementById('toast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('show'); }, 2400);
  }

  /* AJAX add to cart */
  var form = root.querySelector('form[action$="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      var v = currentVariant();
      var allSelected = root.querySelectorAll('[data-opt-group]').length === Object.keys(selected).length;
      if (!allSelected) { e.preventDefault(); showToast('Select your options first'); return; }
      if (!v || !v.available) { e.preventDefault(); showToast('That option is sold out'); return; }
      if (!window.fetch) return; // graceful: native form submit
      e.preventDefault();
      var btns = root.querySelectorAll('[data-add]');
      btns.forEach(function (b) { b.classList.add('added'); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: q })
      }).then(function (r) { return r.json(); }).then(function (item) {
        showToast('Added — ' + item.product_title + ' · ' + (item.variant_title || '') + ' · ' + q);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        document.querySelectorAll('.nav__shop').forEach(function (el) {
          el.innerHTML = el.getAttribute('data-base-label') || 'Cart';
          if (cart.item_count > 0) el.innerHTML += ' (' + cart.item_count + ')';
        });
      }).catch(function () { showToast('Could not add — try again'); })
        .finally(function () { setTimeout(function () { btns.forEach(function (b) { b.classList.remove('added'); }); }, 1400); });
    });
  }

  /* accordion */
  document.querySelectorAll('.acc__h').forEach(function (h) {
    h.addEventListener('click', function () {
      var it = h.parentElement, c = it.querySelector('.acc__c');
      var open = it.classList.toggle('open');
      c.style.maxHeight = open ? c.scrollHeight + 'px' : 0;
    });
  });
  var first = document.querySelector('.acc__item');
  if (first) { first.classList.add('open'); var c = first.querySelector('.acc__c'); if (c) c.style.maxHeight = c.scrollHeight + 'px'; }

  /* mobile sticky bar */
  var bar = document.getElementById('stickybar'), buy = document.getElementById('buy');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(buy);
  }

  /* marquee */
  var mq = document.getElementById('mq1');
  if (mq && !mq.innerHTML.trim()) {
    var items = ['Move Different', 'Forward Always', 'Velocity State', 'No Standing Still', 'Motion Is Identity'];
    var html = '';
    for (var r = 0; r < 2; r++) { items.forEach(function (t) { html += '<span>' + t + '<b> ///</b><i class="dot"></i></span>'; }); }
    mq.innerHTML = html;
    window.addEventListener('load', function () {
      if (typeof gsap !== 'undefined' && !(window.TM && window.TM.reduce)) {
        var w = mq.scrollWidth / 2; gsap.to(mq, { x: -w, duration: 30, ease: 'none', repeat: -1 });
      }
    });
  }

  update();
})();
